import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { updateSpinnerState } from '../../../../actions/spinner';
import { apiCall } from '../../../../middlewares/api';
import { apiCallConsts } from '../../../../constants/apiCallConsts';
import NewTable from '../../../../components/common/NewTable';
import { allOptions, pricingListColumns } from '../utils';
import { updateToastInfo } from '../../../../actions/settings';
import { Badge, Button, Form } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRotateLeft,
  faBroom,
  faCheck,
  faRotateRight,
  faSliders,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { setSelectedRequestInStore } from '../../../../actions/oms/pricingRequests';
import { rolesConstants } from '../../../../constants/roles';
import ExcelDownloadReport from '../../../../components/common/excel/download';
import FilterOrders from '../../orders/FIlterOrders';
import { useFetchOMSProducts } from '../../custom-hooks/useFetchOMSProducts';
import { arrayToDropdownOptions } from '../../../../utils/sms/arrayToDropdownOptions';
import AsyncDropdown from '../../../../components/AsyncDropdown';
import { debounce } from '../../../../utils/debounce';
import DatePicker from '../../../tripPayments/DatePicker';

const CommonRequestPage = (props) => {
  const { pageType, pageTitle } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams({});
  const userName = useSelector((state) => state?.user?.user?.username || '');
  const roles = useSelector((state) => state?.user?.preferences?.roles || []);
  const productsMap = useSelector(
    (state) => state?.allProducts?.productsMap || {}
  );
  const [openFilter, setOpenFilter] = useState(true);
  const [requests, setRequests] = useState([]);
  const [selectedRequests, setSelectedRequests] = useState([]);
  // const [queryParam, setQueryParam] = useState({});
  const [flag, setFlag] = useState(true);
  const [filters, setFilters] = useState({
    vanNo: [],
    startDate: null,
    endDate: null,
  });
  const vanNoOptions = useMemo(
    () => arrayToDropdownOptions(Object.keys(productsMap)),
    [productsMap]
  );

  useFetchOMSProducts();

  const onRowSelect = (selected, objectId) => {
    if (selected) {
      setSelectedRequests((prev) => {
        const selectedItem = requests.find(
          (item) => item.objectId === objectId
        );
        return [...prev, selectedItem];
      });
    } else {
      setSelectedRequests((prev) =>
        prev.filter((item) => item.objectId !== objectId)
      );
    }
    setRequests((prev) =>
      prev.map((item) =>
        item.objectId === objectId ? { ...item, isSelected: selected } : item
      )
    );
  };

  const fetchRequest = async (paramargs = {}) => {
    try {
      const params = {
        userName,
        status: pageType === 'approved' ? '' : pageType,
        isAdmin:
          roles?.includes(rolesConstants.ADMIN) ||
          roles?.includes(rolesConstants.SUPER_ADMIN),
        isPending: pageType === 'pending',
        ...Object.fromEntries(searchParams.entries()),
        ...paramargs,
        // ...Object.fromEntries(searchParams), // Add search params to the query
        // // Add filter parameters conditionally
        // ...(filters.vanNo.length > 0 && {
        //   vanNo: filters.vanNo.map((item) => item.value).join(','),
        // }), // Convert array of objects to comma-separated string
        // ...(filters.startDate && {
        //   startDate: filters.startDate.toISOString(),
        // }),
        // ...(filters.endDate && { endDate: filters.endDate.toISOString() }),
      };
      dispatch(updateSpinnerState(true));
      const response = await apiCall(
        apiCallConsts.GET_METHOD,
        'internal/pricing',
        params
      );
      setRequests(response);
    } catch (error) {
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: t('failed!'),
          message: error.message,
        })
      );
    } finally {
      dispatch(updateSpinnerState(false));
    }
  };

  const onSelectAll = (selected) => {
    if (selected) {
      requests.forEach((each) => onRowSelect(true, each.objectId));
    } else {
      requests.forEach((each) => onRowSelect(false, each.objectId));
    }
  };

  const updateRequest = async (data) =>
    await apiCall(apiCallConsts.PUT_METHOD, 'internal/pricing/update', data);

  const handleRejectedClick = async (found) => {
    try {
      dispatch(updateSpinnerState(true));
      console.log(selectedRequests);
      const data = {
        id:
          selectedRequests.length > 0
            ? selectedRequests.map((request) => request.objectId)
            : [found.objectId],
        status: 'rejected',
        userName: userName,
      };
      await updateRequest(data);
      setSelectedRequests([]);
      await fetchRequest();
      dispatch(
        updateToastInfo({
          show: true,
          type: 'success',
          title: '',
          message: 'Your request has been successfully rejected!',
        })
      );
    } catch (error) {
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: '',
          message: error.message,
        })
      );
    } finally {
      dispatch(updateSpinnerState(false));
    }
  };

  const handleApprovedClick = async (found) => {
    try {
      dispatch(updateSpinnerState(true));
      const data = {
        id:
          selectedRequests.length > 0
            ? selectedRequests.map((request) => request.objectId)
            : [found.objectId],
        status: 'approved',
        userName: userName,
      };
      await updateRequest(data);
      setSelectedRequests([]);
      await fetchRequest();
      dispatch(
        updateToastInfo({
          show: true,
          type: 'success',
          title: '',
          message: 'Your request has been successfully approved!',
        })
      );
    } catch (error) {
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: '',
          message: error.message,
        })
      );
    } finally {
      dispatch(updateSpinnerState(false));
    }
  };

  const onActionClick = (option, id) => {
    console.log(option, id);
    const found = requests.find((request) => request.objectId === id);
    console.log(found);
    if (option === allOptions.view) {
      //   dispatch(setSelectedRequestInStore(found));
      navigate(`/oms/requests/${id}`);
    } else if (option === allOptions.accept) {
      setSelectedRequests(found);
      handleApprovedClick(found);
      return;
    } else if (option === allOptions.reject) {
      setSelectedRequests(found);
      handleRejectedClick(found);
      return;
    }
  };

  // useEffect(() => {
  //   fetchRequest();
  // }, [flag]);

  const fetchOptions = useCallback(
    debounce(async (inputValue, options) => {
      if (inputValue.length > 2) {
        try {
          const filteredOptions = options?.filter((product) =>
            product.value.toLowerCase().includes(inputValue.toLowerCase())
          );
          return filteredOptions;
        } catch (e) {
          console.log(e);
        }
      }
    }),
    []
  );

  const applyFilters = () => {
    const newParams = {};
    if (filters.vanNo.length > 0) {
      newParams.vanNo = filters.vanNo.map((item) => item.value).join(',');
    }
    if (filters.startDate) {
      newParams.startDate = filters.startDate.toISOString();
    }
    if (filters.endDate) {
      newParams.endDate = filters.endDate.toISOString();
    }

    setSearchParams(newParams);
    // fetchRequest(newParams);
  };

  const handleReset = () => {
    setFilters({
      vanNo: [],
      startDate: null,
      endDate: null,
    });
    setSearchParams({});
    // fetchRequest({});
  };

  useEffect(() => {
    const paramsObj = Object.fromEntries(searchParams.entries());
    setFilters({
      vanNo: paramsObj.vanNo
        ? paramsObj.vanNo.split(',').map((v) => ({ value: v, label: v }))
        : [],
      startDate: paramsObj.startDate ? new Date(paramsObj.startDate) : null,
      endDate: paramsObj.endDate ? new Date(paramsObj.endDate) : null,
    });

    fetchRequest();
  }, [searchParams]);

  return (
    <>
      <div
        className="fw-medium fs-4 mb-3"
        style={{ color: 'rgba(68, 68, 68, 1)' }}
      >
        {t(pageTitle)}
      </div>
      {selectedRequests.length > 0 && (
        <div className="mb-3 d-flex gap-3">
          <Button
            variant="white"
            className="btn-export"
            size="md"
            onClick={handleRejectedClick}
          >
            <FontAwesomeIcon icon={faXmark} />
            &nbsp;&nbsp;{t('Reject Selected Request')}
          </Button>
          <Button
            variant="white"
            size="md"
            className="btn-export"
            onClick={handleApprovedClick}
          >
            <FontAwesomeIcon icon={faCheck} />
            &nbsp;&nbsp; {t('Approve Selected Request')}
          </Button>
        </div>
      )}
      <div className="d-flex mb-2 justify-content-end gap-3">
        <Button
          variant="white"
          size="md"
          className="btn-export"
          onClick={() => setOpenFilter(!openFilter)}
        >
          <FontAwesomeIcon icon={faSliders} />
          &nbsp;&nbsp;{t('Filter')}
        </Button>
        <Button
          variant="white"
          size="md"
          className="btn-export"
          onClick={() => fetchRequest()}
        >
          <FontAwesomeIcon icon={faRotateRight} />
          &nbsp;&nbsp; {t('Refresh')}
        </Button>
        <ExcelDownloadReport
          data={requests || []}
          fileName={`${pageType} requests`}
        />
      </div>
      <>
        <div
          className="table-settings mt-2 mb-4"
          style={{
            background: '#EAEDF2',
            maxHeight: openFilter ? '700px' : '0px',
            overflow: openFilter ? '' : 'hidden', // Ensure content is hidden when collapsed
            transition: 'max-height 300ms ease-in-out', // Smooth transition when toggling
          }}
        >
          <div style={{ gap: 8, display: 'flex' }}>
            <Form.Group
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)', // Three columns
                gap: '20px', // Gap between elements
                width: '100%',
                backgroundColor: 'white',
                padding: 20,
              }}
            >
              <div>
                <Form.Label>VAN NO.</Form.Label>
                <AsyncDropdown
                  onChange={(option) => {
                    // console.log(option);
                    setFilters((prev) => ({ ...prev, vanNo: option }));
                  }}
                  style={{
                    height: 38,
                    width: '100%',
                  }}
                  isMultiSelect={true}
                  value={filters?.vanNo}
                  backgroundColor={'#FFF'}
                  optionColor={'rgba(240, 240, 240, 1)'}
                  disabled={false}
                  fetchOptions={(e) => fetchOptions(e, vanNoOptions)}
                  placeholder={t('Select vanNo')}
                />
              </div>

              <div>
                <Form.Label>START DATE</Form.Label>
                <DatePicker
                  value={filters.startDate}
                  setValue={(date) =>
                    setFilters((prev) => ({ ...prev, startDate: date }))
                  }
                  placeholder="Start Date"
                  backgroundColor="#FFF"
                />
              </div>

              <div>
                <Form.Label>END DATE</Form.Label>
                <DatePicker
                  value={filters.endDate}
                  setValue={(date) =>
                    setFilters((prev) => ({ ...prev, endDate: date }))
                  }
                  placeholder="End Date"
                  backgroundColor="#FFF"
                />
              </div>

              <div
                style={{
                  gridColumn: 'span 3', // Span across all columns
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '10px',
                }}
              >
                <Button
                  variant="white"
                  className="fa-export"
                  onClick={handleReset}
                  style={{
                    width: '150px',
                    height: '38px',
                    borderRadius: 0,
                    background: '#EAEDF2',
                  }}
                >
                  <FontAwesomeIcon icon={faArrowRotateLeft} />
                  &nbsp;&nbsp;{t('Reset')}
                </Button>

                <Button
                  variant="white"
                  className="fa-export"
                  onClick={applyFilters}
                  style={{
                    width: '150px',
                    height: '38px',
                    borderRadius: 0,
                    border: '1px solid #262B40',
                  }}
                >
                  <FontAwesomeIcon icon={faSliders} />
                  &nbsp;&nbsp;{t('Apply Filter')}
                </Button>
              </div>
            </Form.Group>
          </div>
        </div>
      </>
      <NewTable
        // id={`Pricing${pageType}Table`}
        id={'objectId'}
        data={requests}
        columns={
          pageType === 'pending'
            ? pricingListColumns(
                pageType,
                onActionClick,
                roles,
                onRowSelect,
                onSelectAll
              )
            : pricingListColumns(pageType, onActionClick)
        }
        isNewEmptyTable={true}
      />
    </>
  );
};

export default CommonRequestPage;
